import { cx } from 'cvb';
import PropTypes from 'prop-types';
import { useAdditionalPDPLabel } from '../hooks/useAdditionalPDPLabel';
import { AdditionalPDPLabelStyles } from './style';

const AdditionalPDPLabel = ({ label, type, productType, desktop }) => {
  const hookData = useAdditionalPDPLabel({ label, type, productType, desktop });

  const {
    processedDescription,
    moreInfoLink,
    linkDisplayText,
    iconStyle,
    hasDescription,
    hasMoreInfoLink,
    shouldRender,
  } = hookData;

  if (!shouldRender) {
    return null;
  }

  const blockClass = 'additional-pdp-label';
  const containerClasses = cx(
    blockClass,
    type === 'warranty' && `${blockClass}--warranty`,
    productType === 'softline' && !desktop && `${blockClass}--softline`
  );

  return (
    <div className={containerClasses}>
      <div className={`${blockClass}__icon-container`}>
        <span className={`${blockClass}__icon`} style={iconStyle} />
      </div>
      <div className={`${blockClass}__content`}>
        <div className={`${blockClass}__text`}>
          {hasDescription && (
            <span
              className={`${blockClass}__description`}
              dangerouslySetInnerHTML={{
                __html: processedDescription,
              }}
            />
          )}
          {hasMoreInfoLink && (
            <a
              className={`${blockClass}__link`}
              href={moreInfoLink}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={linkDisplayText}
            >
              {linkDisplayText}
            </a>
          )}
        </div>
      </div>
      <style jsx>{AdditionalPDPLabelStyles}</style>
    </div>
  );
};

AdditionalPDPLabel.propTypes = {
  label: PropTypes.shape({
    title: PropTypes.string,
    icon: PropTypes.string,
    description: PropTypes.string,
    moreInfoLink: PropTypes.string,
    moreInfoDisplayText: PropTypes.string,
  }),
  type: PropTypes.string,
  productType: PropTypes.string,
  desktop: PropTypes.bool,
};

AdditionalPDPLabel.defaultProps = {
  label: {},
  type: 'addToCart',
  productType: 'hardline',
  desktop: false,
};

export { AdditionalPDPLabel };
export default AdditionalPDPLabel;
